module.exports = __webpack_public_path__ + "img/16581304_L.def48d17.png";